import AxiosClient from "../../../services/axios.services";

class DisciplinaryActionTypesServices {
  getDisciplinaryActionTypes = (params) =>
    AxiosClient.get(
      "/api/app/sanciones_accion_disciplinaria/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  saveDisciplinaryActionTypes = (data) =>
    AxiosClient.post(
      "/api/app/sanciones_accion_disciplinaria/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editDisciplinaryActionTypes = (id, data) =>
    AxiosClient.put(
      `/api/app/sanciones_accion_disciplinaria/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteDisciplinaryActionTypes = (id) =>
    AxiosClient.delete(
      `/api/app/sanciones_accion_disciplinaria/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new DisciplinaryActionTypesServices();
